<template>
  <div class="faq-area ptb-100">
    <div class="container mw-1356">
      <div class="row align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="faq-content">
            <span class="top-title">الأسئلة الشائعة</span>
            <h2>إجابات لكل ما تود معرفته عن الخدمة</h2>
          </div>

          <div class="accordion style-two">
            <div
              class="accordion-item"
              v-for="(item, index) in accordionItems"
              :key="index"
              :class="{ active: activeIndex === index }"
            >
              <h2 class="accordion-header">
                <button
                  class="accordion-button pt-0"
                  type="button"
                  :aria-expanded="activeIndex === index ? 'true' : 'false'"
                  @click="toggleAccordion(index)"
                >
                  {{ item.question }}
                </button>
              </h2>
              <div
                class="accordion-collapse collapse show"
                v-show="activeIndex === index"
              >
                <div class="accordion-body">
                  <p>{{ item.answer }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="faq-img">
            <img src="@/assets/images/faq-2.png" alt="faq" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "FAQ",
  setup() {
    const activeIndex = ref<number>(0);

    const accordionItems = [
      {
        question: "ما هي الأجهزة الشاشات والأنظمة التي تدعمونها؟",
        answer:
          "نحن ندعم جميع الأجهزة الذكية وأنظمة التشغيل تقريباً. يشمل ذلك الشاشات الذكية (Smart TV مثل Samsung و LG عن طريق واجهة التطبيق)، أجهزة Firestick و Google TV، الهواتف الذكية (Android و iOS)، الحواسيب، والآيباد. لا تحتاج لخبرة تقنية، ستحصل على كود للتفعيل الفوري وتوجيه خطوة بخطوة.",
      },
      {
        question: "كيف يمكنني الحصول على الدعم الفني بعد الاشتراك؟",
        answer:
          "فريق الدعم الفني متواجد لمساعدتك على مدار الساعة (24/7) عبر الواتساب مباشرة. سواء كنت بحاجة للمساعدة في إعداد التطبيق، تحديث القنوات، أو أي استفسار تقني آخر، نحن هنا لضمان عمل الخدمة بثبات مطلق.",
      },
      {
        question: "كم من الوقت يستغرق تفعيل الخدمة بعد الدفع؟",
        answer:
          "التفعيل فوري وآمن تماماً. بمجرد إتمام الطلب والتواصل معنا عبر الواتساب، يقوم فريقنا بإنشاء وإرسال بيانات الاشتراك والروابط المخصصة لك في غضون دقائق معدودة لتستمتع بالمشاهدة فوراً.",
      },
      {
        question: "ما هي سياسة ضمان استرجاع الأموال؟",
        answer:
          "ثقتكم هي أولويتنا، لذلك نقدم ضماناً ذهبياً كاملاً طوال فترة الاشتراك. إذا واجهت أي مشكلة فنية مستعصية لم نتمكن من حلها، أو إذا لم تكن راضياً عن جودة وثبات السيرفرات، يمكنك طلب استرجاع أموالك وفقاً للشروط المحددة بكل مرونة.",
      },
      {
        question: "هل أحتاج إلى سرعة إنترنت عالية لتشغيل القنوات بدون تقطيع؟",
        answer:
          "سيرفراتنا مجهزة بأحدث تقنيات البث الصديقة للإنترنت وتدعم التغيير التلقائي للجودة. للتشغيل المستقر بجودة FHD أو 4K، نوصي بسرعات إنترنت تبدأ من 20 ميغابت في الثانية (Mbps) فما فوق لضمان أداء خارق وثبات تام أثناء المباريات الكبرى.",
      },
    ];

    const toggleAccordion = (index: number) => {
      activeIndex.value = activeIndex.value === index ? -1 : index;
    };

    return {
      activeIndex,
      toggleAccordion,
      accordionItems,
    };
  },
});
</script>